module.exports = __webpack_public_path__ + "static/img/283_TO8_2429_og.8353f7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/283_TO8_2429_og.jpg
// module id = nGNY
// module chunks = 0